import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconImageGallery$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconImageGallery extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '415e54ca4723fbca2e1d9fa79f4aee925e00d6af', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '53925822d25128b87fc50a7ef8ab8d54d679796f', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'e8fee703c1f9dda6dad1944ec12194954316f931', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5 4v-.5a.5.5 0 0 1 .5-.5h14a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5H19a.5.5 0 0 1-.5-.5v-10h-13A.5.5 0 0 1 5 4M2.5 6.49A.5.5 0 0 0 2 7v10.5a.5.5 0 0 0 .5.5H16a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5zM15 8v8.5H3.5V8zm-4.19 3.24-2.3 3.31L7 12.3a.21.21 0 0 0-.33 0L5 14.69a.2.2 0 0 0 .16.31h8.24a.2.2 0 0 0 .16-.31l-2.39-3.45a.2.2 0 0 0-.36 0M9 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-image-gallery", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-image-gallery"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-image-gallery":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconImageGallery$1);
            }
            break;
    } });
}

const CosmosIconImageGallery = CosmosIconImageGallery$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconImageGallery, defineCustomElement };
